import ShopProfile from 'views/web/shop/ShopProfile';
import { NextPageWithLayout } from 'pages/_app';
import { getShopInfoData } from 'api/shop';
import { GetServerSideProps } from 'next';
import { useContext } from 'react';
import { isMobileMall } from 'libs/utils';
import { genProfileProps } from 'libs/profile-repo';
import Profile from 'views/Profile';
import { MediaQueryContext } from 'libs/contexts';
import { getDynamicEvaluation } from 'api/shop';

const ShopProfilePage: NextPageWithLayout = (props: any) => {
  const { isMobile } = useContext(MediaQueryContext);
  return isMobile ? <Profile {...props} /> : <ShopProfile {...props} />;
};

export const getServerSideProps: GetServerSideProps = async (ctx) => {
  if (!isMobileMall(ctx?.req)) {
    const props = {
      shopData: {},
      evaluationData: {},
    };
    const serverHeaders = ctx.req.headers;
    const { shopSysNo } = ctx.query;
    const shopData: any = await getShopInfoData(shopSysNo, {
      serverSide: true,
      headers: serverHeaders,
    });

    const evaluationRes = await getDynamicEvaluation({
      serverSide: true,
      headers: serverHeaders,
      json: {
        evaluateObjectType: 2,
        status: 1,
        evaluateObjectSysNo: shopData?.data?.supplierSysNo,
        pageNo: 1,
        pageSize: 10,
      },
    });

    if (shopData?.code === 200) {
      const originShopData = shopData.data;
      props.shopData = originShopData;
      props.evaluationData = evaluationRes.data;
    }

    return {
      props,
    };
  } else {
    const props = await genProfileProps(ctx as any);
    return { props };
  }
};

ShopProfilePage.layoutProps = {
  title: '店铺档案',
};

export default ShopProfilePage;
